import { render, staticRenderFns } from "./BookableBookingEdit.vue?vue&type=template&id=16482d30&scoped=true"
import script from "./BookableBookingEdit.vue?vue&type=script&lang=js"
export * from "./BookableBookingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16482d30",
  null
  
)

export default component.exports